import * as GUID from './GUID';

const _stateId = Symbol();

export const StateMixin = superclass => class extends superclass {
	get stateId() {
		return this[_stateId];
	}
	set stateId(v) {
		if(v !== null && !GUID.isGUID(v))
			throw new TypeError('stateId must be a GUID formatted string.');
		this[_stateId] = v;
	}
	getState() {
		throw new Error('getState method not implemented.');
	}
	setState() {
		throw new Error('setState method not implemented.');
	}
};